import SwitchMUI from './SwitchMUI';

export default SwitchMUI;
